import { ViewWebOrderDeliverySetUpDto } from "./view-web-order-delivery-set-up-dto";
import { ViewWebOrderGstSetupDto } from "./view-web-order-gst-setup-dto";

export class WebOrderDeliverySetupDto {
    viewWebOrderDeliverySetUpDto: ViewWebOrderDeliverySetUpDto[] = [];
    viewWebOrderGstSetupDto: ViewWebOrderGstSetupDto;
    deliveryChargeByDistance: number;
}